import { Fragment } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { IonLabel, IonSegment, IonSegmentButton } from "@ionic/react";

import { TimetableType } from "../../hooks/useTimetablePeriods";

import "./TimetableSelector.css";

interface ContainerProps extends RouteComponentProps<any> {
  timetableType: TimetableType;
  onSelected: (type: TimetableType) => void;
}

// eslint-disable-next-line react-refresh/only-export-components
const TimetableSelector: React.FC<ContainerProps> = ({
  timetableType,
  onSelected,
}) => {
  const handleTypeSelected = (e: any) => {
    onSelected(e?.detail?.value);
  };

  return (
    <Fragment>
      <IonSegment
        color="primary"
        value={timetableType}
        mode="ios"
        onIonChange={handleTypeSelected}
      >
        {/* <IonSegmentButton value="All" mode="ios">
          <IonLabel>"All"</IonLabel>
        </IonSegmentButton> */}
        <IonSegmentButton value="Secondary" mode="ios">
          <IonLabel>"Secondary"</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton value="Junior" mode="ios">
          <IonLabel>"Junior"</IonLabel>
        </IonSegmentButton>
      </IonSegment>
    </Fragment>
  );
};

export default withRouter(TimetableSelector);
